import { css } from "@emotion/react";
import YouTube from "react-youtube";

import { EpisodeItem, EpisodeItemProps } from "../molecules";
import { useGetMediaSize } from "../../hooks";
import {
  episode1,
  episode2,
  episode3,
  episode4,
  episode5,
  lastEpisode,
} from "../../txts/episode";

type Props = {
  title: string;
};

const items: Omit<EpisodeItemProps, "episode">[] = [
  {
    title: "転校生",
    imgPaths: [
      "/img/episode/1/1.jpg",
      "/img/episode/1/2.jpg",
      "/img/episode/1/3.jpg",
    ],
    description: episode1,
  },
  {
    title: "写真部 ～コスプレ対決～",
    imgPaths: [
      "/img/episode/2/1.jpg",
      "/img/episode/2/2.jpg",
      "/img/episode/2/3.jpg",
    ],
    description: episode2,
  },
  {
    title: "保健室",
    imgPaths: [
      "/img/episode/3/1.jpg",
      "/img/episode/3/2.jpg",
      "/img/episode/3/3.jpg",
    ],
    description: episode3,
  },
  {
    title: "プール",
    imgPaths: [
      "/img/episode/4/1.jpg",
      "/img/episode/4/2.jpg",
      "/img/episode/4/3.jpg",
    ],
    description: episode4,
  },
  {
    title: "体育館倉庫",
    imgPaths: [
      "/img/episode/5/1.jpg",
      "/img/episode/5/2.jpg",
      "/img/episode/5/3.jpg",
    ],
    description: episode5,
  },
  {
    title: "（最終話）彼女の部屋",
    imgPaths: [
      "/img/episode/6/1.jpg",
      "/img/episode/6/2.jpg",
      "/img/episode/6/3.jpg",
    ],
    description: lastEpisode,
  },
];

const youtubeID = "B4411jVKCVs";

const Episode: React.FC<Props> = ({ title }) => {
  const { width, height } = useGetMediaSize({});
  return (
    <div id="episode" css={mainStyle}>
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>{title}</div>
          <div css={borderStyle}></div>
        </div>
        {width > 0 && <YouTube videoId={youtubeID} opts={{ width, height }} />}
        {items.map((item, idx) => (
          <EpisodeItem
            key={"episode" + "-" + (idx + 1)}
            episode={idx + 1}
            {...item}
          />
        ))}
      </div>
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  width: 100%;
`;

const contentsWrapper = css`
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const upperTitleWrapperStyle = css`
  width: 85%;
  max-width: 1125px;
  display: flex;
  align-items: center;
  padding: 40px 30px 30px;

  @media (max-width: ${spSize}px) {
    padding: 30px 20px 10px;
    padding-bottom: 10px !important;
  }
`;

const borderStyle = css`
  height: 3px;
  background-color: white;
  flex-grow: 1;
`;

const titleStyle = css`
  padding: 0 15px;
  font-family: MyFont;
  font-size: 18px;
  font-weight: 500;
  line-height: 100%;
`;

export default Episode;
